import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { ApplicationPageFormValues } from '@presentation/pages';
import { useCallback } from 'react';

export const APPLICATION_CONFIRM_CREATE_APPLICATION = graphql(`
  mutation ApplicationConfirmCreateApplication($data: CreateApplicationInput!) {
    confirmCreateApplication(data: $data) {
      id
    }
  }
`);

export interface CreateApplicationFromFormParams {
  breederId: number;
  values: ApplicationPageFormValues;
}

export const useConfirmCreateApplication = () => {
  const [confirmCreateApplication, { loading }] = useMutation(
    APPLICATION_CONFIRM_CREATE_APPLICATION,
  );

  const confirmCreateApplicationFromForm = useCallback(
    async (params: CreateApplicationFromFormParams) => {
      const { values, breederId } = params;
      const {
        accommodation,
        breedPreferenceId,
        experiences,
        genderPreferences,
        motive,
        otherAnimals,
        otherPreferences,
        timeAlone,
        trainers,
        questions,
      } = values;

      const response = await confirmCreateApplication({
        variables: {
          data: {
            accommodation: accommodation!,
            dogBreedId: breedPreferenceId!,
            dogBreederId: breederId,
            experiences: experiences!,
            genderPreferences: genderPreferences!,
            motive: motive!,
            otherAnimals: otherAnimals!,
            otherPreferences: otherPreferences!,
            timeAlone: timeAlone!,
            trainers: trainers!,
            questions: questions!,
          },
        },
      });

      return response.data?.confirmCreateApplication.id;
    },
    [confirmCreateApplication],
  );

  return {
    confirmCreateApplicationFromForm,
    confirmCreateApplicationLoading: loading,
  };
};
